(function () {
  var MOBILE_HEADER_SELECTOR = '#mobile-header.breakout-mobile-header';
  var OPEN_CLASS = 'mobile-header--menu-open';
  var WRAPPER_OPEN_CLASS = 'breakout-mobile-menu-wrapper-open';
  var HTML_OPEN_CLASS = 'breakout-mobile-menu-open';
  var MOBILE_QUERY = window.matchMedia('(max-width: 798px)');

  function getMobileHeader() {
    return document.querySelector(MOBILE_HEADER_SELECTOR);
  }

  function isMobileMenuViewport() {
    return MOBILE_QUERY.matches || document.documentElement.classList.contains('breakout-header-compact');
  }

  function getMobileHeaderWrapper(header) {
    if (!header) return null;

    return (
      document.getElementById('mobile-header-sticky-wrapper') ||
      document.getElementById('mobile-header-header-sticky-wrapper') ||
      header.closest('.header-sticky-wrapper') ||
      header.parentElement
    );
  }

  function isMenuOpen(header) {
    return !!(header && header.classList.contains(OPEN_CLASS));
  }

  function hasScrollLock() {
    return (
      document.body.classList.contains('mobile-menu--opened') ||
      document.documentElement.classList.contains(HTML_OPEN_CLASS) ||
      document.body.style.position === 'fixed'
    );
  }

  function lockPageScroll(scrollY) {
    document.documentElement.classList.add(HTML_OPEN_CLASS);
    document.body.classList.add('mobile-menu--opened');
    document.body.setAttribute('data-current-position', String(scrollY));
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + scrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }

  function unlockPageScroll() {
    if (!hasScrollLock()) {
      return;
    }

    var scrollY = parseInt(document.body.getAttribute('data-current-position') || '0', 10);

    document.documentElement.classList.remove(HTML_OPEN_CLASS);
    document.body.classList.remove('mobile-menu--opened');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';

    window.scrollTo({ top: scrollY, left: 0, behavior: 'auto' });
  }

  function setToggleState(isOpen) {
    document.querySelectorAll(MOBILE_HEADER_SELECTOR + ' .mobile-menu__toggle-icon').forEach(function (icon) {
      icon.classList.toggle('is-active', isOpen);
    });

    var toggle = document.querySelector(MOBILE_HEADER_SELECTOR + ' [data-show-mobile-menu]');
    if (toggle) {
      toggle.setAttribute('data-show-mobile-menu', isOpen ? 'true' : 'false');
    }

    if (window.jQuery) {
      window.jQuery(MOBILE_HEADER_SELECTOR + ' .mobile-menu__toggle-icon').toggleClass('is-active', isOpen);
      window.jQuery('[data-show-mobile-menu]').attr('data-show-mobile-menu', isOpen ? 'true' : 'false');
    }
  }

  function disableThemeSticky() {
    if (window.Shopify && Shopify.theme && Shopify.theme.mobileMenu && typeof Shopify.theme.mobileMenu.disableSticky === 'function') {
      Shopify.theme.mobileMenu.disableSticky();
    }
  }

  function enableThemeSticky() {
    if (
      window.Shopify &&
      Shopify.theme &&
      Shopify.theme.mobileMenu &&
      typeof Shopify.theme.mobileMenu.enableSticky === 'function' &&
      Shopify.theme.jsHeader &&
      Shopify.theme.jsHeader.enable_sticky === true &&
      isMobileMenuViewport()
    ) {
      Shopify.theme.mobileMenu.enableSticky();
    }
  }

  function hideThemeDrawers() {
    if (window.Shopify && Shopify.theme && Shopify.theme.jsAjaxCart) {
      if (typeof Shopify.theme.jsAjaxCart.hideMiniCart === 'function') {
        Shopify.theme.jsAjaxCart.hideMiniCart();
      }
      if (typeof Shopify.theme.jsAjaxCart.hideDrawer === 'function') {
        Shopify.theme.jsAjaxCart.hideDrawer();
      }
    }
  }

  function openMenu() {
    if (!isMobileMenuViewport()) {
      return;
    }

    var header = getMobileHeader();
    if (!header || isMenuOpen(header)) {
      return;
    }

    var scrollY = window.scrollY;
    lockPageScroll(scrollY);
    hideThemeDrawers();
    disableThemeSticky();

    header.classList.add(OPEN_CLASS);

    var wrapper = getMobileHeaderWrapper(header);
    if (wrapper && wrapper !== document.body && wrapper !== document.documentElement) {
      wrapper.classList.add(WRAPPER_OPEN_CLASS);
    }

    setToggleState(true);
  }

  function closeMenu() {
    var header = getMobileHeader();
    if (!header || !isMenuOpen(header)) {
      if (hasScrollLock()) {
        unlockPageScroll();
      }
      return;
    }

    header.classList.remove(OPEN_CLASS);

    var wrapper = getMobileHeaderWrapper(header);
    if (wrapper && wrapper !== document.body && wrapper !== document.documentElement) {
      wrapper.classList.remove(WRAPPER_OPEN_CLASS);
      wrapper.style.height = '';
    }

    setToggleState(false);
    unlockPageScroll();
    enableThemeSticky();
  }

  function toggleMenu() {
    if (!isMobileMenuViewport()) {
      return;
    }

    if (isMenuOpen(getMobileHeader())) {
      closeMenu();
    } else {
      openMenu();
    }
  }

  function resetMenuForDesktop() {
    if (isMobileMenuViewport()) {
      return;
    }

    var header = getMobileHeader();
    if (header) {
      header.classList.remove(OPEN_CLASS);
    }

    document.querySelectorAll('.header-sticky-wrapper.breakout-mobile-menu-wrapper-open, #mobile-header-sticky-wrapper.breakout-mobile-menu-wrapper-open, #mobile-header-header-sticky-wrapper.breakout-mobile-menu-wrapper-open').forEach(function (wrapper) {
      wrapper.classList.remove(WRAPPER_OPEN_CLASS);
      wrapper.style.height = '';
    });

    setToggleState(false);
    unlockPageScroll();
  }

  function patchThemeMobileMenu() {
    if (!window.Shopify || !Shopify.theme || !Shopify.theme.mobileMenu || !getMobileHeader()) {
      return false;
    }

    var mm = Shopify.theme.mobileMenu;

    if (mm._breakoutMobileMenuPatched) {
      return true;
    }

    mm.open = function () {
      if (getMobileHeader() && isMobileMenuViewport()) {
        openMenu();
        return;
      }

      if (typeof mm._breakoutOriginalOpen === 'function') {
        mm._breakoutOriginalOpen.call(mm);
      }
    };

    mm.close = function () {
      if (getMobileHeader()) {
        closeMenu();
        return;
      }

      if (typeof mm._breakoutOriginalClose === 'function') {
        mm._breakoutOriginalClose.call(mm);
      }
    };

    mm._breakoutMobileMenuPatched = true;
    return true;
  }

  function initBreakoutMobileMenu() {
    var header = getMobileHeader();
    if (!header || header.dataset.breakoutMenuInit === 'true') {
      return;
    }

    header.dataset.breakoutMenuInit = 'true';

    header.addEventListener(
      'click',
      function (event) {
        if (!isMobileMenuViewport()) {
          return;
        }

        if (
          event.target.closest('.mobile-menu__toggle-icon') ||
          event.target.closest('.mobile-menu__toggle-button')
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          toggleMenu();
        }
      },
      true
    );

    initBreakoutMobileNavInteraction();
    patchThemeMobileMenu();
    resetMenuForDesktop();
  }

  function initBreakoutMobileNavInteraction() {
    var menu = document.querySelector('.mobile-header.breakout-mobile-header .mobile-menu');
    if (!menu || menu.dataset.breakoutNavInit === 'true') {
      return;
    }

    menu.dataset.breakoutNavInit = 'true';

    menu.addEventListener(
      'click',
      function (event) {
        var link = event.target.closest('a.mobile-menu__item, a.breakout-mobile-nav__link');
        if (link && menu.contains(link)) {
          event.stopPropagation();
        }
      },
      true
    );

    menu.addEventListener('change', function (event) {
      var input = event.target;
      if (!input.matches('.submenu__input')) {
        return;
      }

      input.blur();
    });
  }

  function waitForSetup(attempts) {
    initBreakoutMobileMenu();

    if (patchThemeMobileMenu()) {
      return;
    }

    if (attempts > 80) {
      return;
    }

    window.setTimeout(function () {
      waitForSetup(attempts + 1);
    }, 50);
  }

  MOBILE_QUERY.addEventListener('change', resetMenuForDesktop);
  window.addEventListener('resize', resetMenuForDesktop, { passive: true });

  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function () {
      resetMenuForDesktop();
    }).observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      waitForSetup(0);
    });
  } else {
    waitForSetup(0);
  }
})();
